const SdkServices = {
  BODY_MEASUREMENT: "bodyMeasurement",
  SIZE_MEASUREMENT: "sizeMeasurement",
  AUTO_TAGGING: "autoTagging", 
  VISUAL_SEARCH: "visualSearch",
  GARMENT_MEASUREMENT: "garmentMeasurement",
};
export default SdkServices;
